<template>
    <div>
        <editor-menu-bar :editor="editor">
            <div slot-scope="{ commands, isActive }" class="fixed-menu" :class="{ 'is-active':isEditing }">
                <button title="Undo" class="with-icon" @click="commands.undo" :style="iconStylesForButton('undo')">
                    Undo
                </button>
                <button title="Redo" class="with-icon" @click="commands.redo" :style="iconStylesForButton('redo')">
                    Redo
                </button>
                <popup-button name="Paragraph" title="Paragraph Style" :iconStyle="iconStylesForButton('paragraph')">
                    <ul class="popup-menu">
                        <li><a href="#" @click.prevent="commands.heading({ level: 1 })">Heading 1</a></li>
                        <li><a href="#" @click.prevent="commands.heading({ level: 2 })">Heading 2</a></li>
                        <li><a href="#" @click.prevent="commands.heading({ level: 3 })">Heading 3</a></li>
                        <li><a href="#" @click.prevent="commands.paragraph">Paragraph</a></li>
                    </ul>
                </popup-button>
                <popup-button name="Table" title="Table" id="create-table-popup-button" :iconStyle="iconStylesForButton('table')">
                    <ul class="popup-menu">
                        <template v-if="isActive.table()">
                            <li><a href="#" @click.prevent="commands.deleteTable">Delete Table</a></li>
                            <li><a href="#" @click.prevent="commands.addRowBefore">Insert Row Before</a></li>
                            <li><a href="#" @click.prevent="commands.addRowAfter">Insert Row After</a></li>
                            <li><a href="#" @click.prevent="commands.deleteRow">Delete Row</a></li>
                            <li><a href="#" @click.prevent="commands.addColumnBefore">Insert Column Before</a></li>
                            <li><a href="#" @click.prevent="commands.addColumnAfter">Insert Column After</a></li>
                            <li><a href="#" @click.prevent="commands.deleteColumn">Delete Column</a></li>
                        </template>
                        <template v-else>
                            <li><a href="#" @click.prevent="clickedCreateTableMenuItem">Create Table</a></li>
                        </template>
                    </ul>
                </popup-button>
                <button @click="commands.horizontal_rule" title="Horizontal Rule">---</button>
                <button title="Bullet List" class="with-icon hide-on-mobile" :class="{ 'is-active': isActive.bullet_list() }" @click="commands.bullet_list" :style="iconStylesForButton('ul')">
                    Bullet List
                </button>
                <button title="Ordered List" class="with-icon hide-on-mobile" :class="{ 'is-active': isActive.ordered_list() }" @click="commands.ordered_list" :style="iconStylesForButton('ol')">
                    Ordered List
                </button>
                <button title="Quote" class="with-icon hide-on-mobile" :class="{ 'is-active': isActive.blockquote() }" @click="commands.blockquote" :style="iconStylesForButton('blockquote')">
                    Quote
                </button>
                <button title="Bold" :class="{ 'is-active': isActive.bold() }" @click="commands.bold" style="font-weight: bold">
                    B
                </button>
                <button title="Italic" :class="{ 'is-active': isActive.italic() }" @click="commands.italic" style="font-style: italic">
                    I
                </button>
                <button title="Underline" :class="{ 'is-active': isActive.underline() }" @click="commands.underline" style="text-decoration: underline">
                    U
                </button>
                <button title="Strike" class="hide-on-mobile" :class="{ 'is-active': isActive.strike() }" @click="commands.strike" style="text-decoration: line-through; font-weight: normal; font-size: 14px">
                    S
                </button>
                <button title="Insert Image" id="insert-image-button" class="with-icon hide-on-mobile" :class="{ 'is-active': isActive.image() }" @click="clickedImageButton" :style="iconStylesForButton('image')">
                    Image
                </button>
                <button title="Link" id="create-link-button" class="with-icon hide-on-mobile" :class="{ 'is-active': isActive.link() }" @click="clickedLinkButton" :style="iconStylesForButton('link')">
                    Link
                </button>
            </div>
        </editor-menu-bar>

        <popover ref="tablePopover" okButtonName="Create" v-on:clicked-ok="finishedCreateTablePopover" >
            <div>
                <table class="create-table-popover-table">
                    <tbody>
                        <tr>
                            <th><label for="create-table-column-count">Columns:</label></th>
                            <td><select id="create-table-column-count" v-model="createTableColumnCount">
                                <option v-for="n in 12" :value="n" v-bind:key="n">{{n}}</option>
                            </select></td>
                        </tr>
                        <tr>
                            <th><label for="create-table-row-count">Rows:</label></th>
                            <td><select id="create-table-row-count" v-model="createTableRowCount">
                                <option v-for="n in 12" :value="n" v-bind:key="n">{{n}}</option>
                            </select></td>
                        </tr>
                        <tr>
                            <td></td>
                            <td>
                                <input type="checkbox" id="create-table-use-headers" v-model="createTableUseHeaders">
                                <label for="create-table-use-headers">Use header row</label>
                            </td>
                        </tr>
                    </tbody>
                </table>
                
            </div>
        </popover>

        <popover ref="linkPopover" okButtonName="Link" @clicked-ok="finishedLinkPopover">
            <label for="create-link-url">Link to:</label>
            <input type="text" id="create-link-url" v-model="createLinkUrl" placeholder="http://desertparadise.org/">
        </popover>

        <popover ref="imagePopover" okButtonName="Insert" @clicked-ok="finishedImagePopover">
            <label for="insert-image-file">Image:</label>
            <input type="file" id="insert-image-file" accept="image/jpeg, image/gif, image/png">
        </popover>

    </div>
</template>

<script>

import { Editor, EditorContent, EditorMenuBar, EditorFloatingMenu, EditorMenuBubble } from 'tiptap'

import iconUndo from '../../assets/img/icons/undo.svg'
import iconRedo from '../../assets/img/icons/redo.svg'
import iconParagraph from '../../assets/img/icons/paragraph.svg'
import iconTable from '../../assets/img/icons/table.svg'
import iconOL from '../../assets/img/icons/ol.svg'
import iconUL from '../../assets/img/icons/ul.svg'
import iconLink from '../../assets/img/icons/link.svg'
import iconQuote from '../../assets/img/icons/quote.svg'
import iconImage from '../../assets/img/icons/image.svg'

import PopupButton from './PopupButton.vue'
import Popover from '@/components/Popover.vue'
import PagesService from '@/services/PagesService'


const icons = {
    undo: iconUndo,
    redo: iconRedo,
    paragraph: iconParagraph,
    table: iconTable,
    ol: iconOL,
    ul: iconUL,
    link: iconLink,
    image: iconImage,
    blockquote: iconQuote
}

export default {
    props: {
        editor: Editor,
        isEditing: Boolean,
        guid: String
    },
    data() {
        return {
            activePopup: '',
            createTableColumnCount: 3,
            createTableRowCount: 3,
            createTableUseHeaders: true,
            createLinkUrl: ''
        }
    },
    components: {
        EditorMenuBar, PopupButton, Popover
    },
    methods: {
        iconStylesForButton(buttonName) {
            return {
                backgroundImage: `url(${icons[buttonName]})`
            }
        },
        clickedCreateTableMenuItem() {
            this.$refs.tablePopover.showFromElement('create-table-popup-button')
        },
        finishedCreateTablePopover() {
            this.editor.commands.createTable({
                rowsCount: this.createTableRowCount,
                colsCount: this.createTableColumnCount,
                withHeaderRow: this.createTableUseHeaders
            })
        },
        clickedLinkButton() {
            if (this.editor.isActive.link()) {
                this.editor.commands.link({ href: null })
            } else {
                this.createLinkUrl = ''
                this.$refs.linkPopover.showFromElement('create-link-button')
            }
        },
        finishedLinkPopover() {
            const baseHref = window.location.href.match(/^https?:\/\/[^/]+\//)[0]
            let shortenedUrl = this.createLinkUrl.replace(baseHref, '/');

            // fix raw email addresses
            if (shortenedUrl.match(/.+@.+\..+/) && !shortenedUrl.match(/^https?:\/\//)) {
                shortenedUrl = 'mailto:' + shortenedUrl
            }

            this.editor.commands.link({ href: shortenedUrl })
        },
        clickedImageButton() {
            const uploadElement = document.getElementById('insert-image-file')
            uploadElement.value = ''

            if (!/safari/i.test(navigator.userAgent)) {
                uploadElement.type = ''
                uploadElement.type = 'file'
            }

            this.$refs.imagePopover.showFromElement('insert-image-button')
        },
        async finishedImagePopover() {
            if (!document.getElementById('insert-image-file').files.length) {
                return;
            }

            // upload the attachment
            const fileToUpload = document.getElementById('insert-image-file').files[0]
            const uploadResponse = await PagesService.uploadAttachment(this.guid, fileToUpload )

            // insert the image
            if (uploadResponse.data && uploadResponse.data.src) {
                this.editor.commands.image(uploadResponse.data)
            }
        }
    }
}
</script>


<style lang="scss">

    .fixed-menu {
        transform: scaleY(0) translateY(-100%);
        opacity: 0; // activated with is-active class
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        background-color: rgba(255, 255, 255, 0.9);
        color: $body-text-color;
        transition: transform 0.5s, opacity 0.5s;
        box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
        z-index: 2;
        text-align: center;

        @supports(-webkit-backdrop-filter: blur(2px)) {
            -webkit-backdrop-filter: blur(2px);
            background-color: rgba(255, 255, 255, 0.8);
        }

        &.is-active {
            transform: scaleY(1.0) translateY(0);
            opacity: 1.0;
        }

        button {
            display: inline-block;
            position: relative;
            border: 0;
            margin: 0;
            padding: 0;
            width: 36px;
            height: 32px;
            font-size: 12px;
            font-weight: bold;
            text-align: center;
            background-color: rgba(0, 0, 0, 0.0);
            cursor: pointer;

            &.with-icon {
                background-size: 12px 12px;
                background-repeat: no-repeat;
                background-position: 50% 55%;
                font-size: 0;
                vertical-align: top;
            }

            &.hide-on-mobile {
                @include mobile {
                    display: none;
                }
                @include mobile-landscape {
                    display: none;
                }
            }

            &.is-active {
                color: blue;
            }

            &:first-child {
                border-left: 0;
            }
        }
    }

    .page table.create-table-popover-table, .page table.create-link-popover-table {
        border: 0;
        box-shadow: none;
        margin-right: 70px;
        width: auto !important;

        tr {
            background-color: transparent !important;

            th {
                border-right-width: 0;
                padding-right: 0;
                text-align: right;
                font-weight: normal;
            }

            td {
                padding-left: 0;
                border: 0 !important;
                background-color: transparent !important;
            }
        }
    }

    #create-link-url {
        width: 300px;
    }

</style>
